import { ClassValue } from 'clsx';
import cn from '../../app/utils/cn';

export const BRAND_NAME = 'Clicker Sphere';

const BLADE_PATH =
  'M38.800 2.078 L94.552 -32.557 A100.000 100.000 0 0 1 81.915 57.358 L21.200 32.563 Z';

const MICRO_PATH =
  'M100.000 0 A100.000 100.000 0 1 1 -100.000 0 A100.000 100.000 0 1 1 100.000 0 Z M46.000 0.000 L23.000 39.837 L-23.000 39.837 L-46.000 0.000 L-23.000 -39.837 L23.000 -39.837 Z';

const BLADE_ROTATIONS = [0, 60, 120, 180, 240, 300];

export type LogoVariant = 'mark' | 'micro';

interface ILogoProps {
  className?: ClassValue;
  variant?: LogoVariant;
  label?: string;
  decorative?: boolean;
}

export default function Logo({
  className,
  variant = 'mark',
  label = BRAND_NAME,
  decorative = false,
}: ILogoProps) {
  const accessibilityProps = decorative
    ? { 'aria-hidden': true as const }
    : { role: 'img', 'aria-label': label };

  return (
    <svg
      viewBox="0 0 200 200"
      focusable="false"
      className={cn('text-text-brand h-20 w-20 shrink-0', className)}
      {...accessibilityProps}
    >
      {variant === 'micro' ? (
        <path
          transform="translate(100 100)"
          fillRule="evenodd"
          fill="currentColor"
          d={MICRO_PATH}
        />
      ) : (
        <g transform="translate(100 100)" fill="currentColor">
          {BLADE_ROTATIONS.map((degrees) => (
            <path
              key={degrees}
              d={BLADE_PATH}
              transform={`rotate(${degrees})`}
            />
          ))}
        </g>
      )}
    </svg>
  );
}
